<template>
  <div class="form-field">
    <label class="form-label">{{ getReferencelabel(label) }}:</label>
    <div>
      <div v-if="type === 'radio'">
        <Radio
          :id="id"
          :options="options"
          :value="value"
          :disabled="disabled"
          :valid="!!errorMessage"
          @update:value="updateModelValue($event)"
        />
      </div>

      <div v-else-if="type === 'select'">
        <Select
          :id="id"
          :options="options"
          :value="value"
          :disabled="disabled"
          :valid="!!errorMessage"
          @update:value="updateModelValue($event)"
        />
      </div>

      <div v-else-if="simpleField.includes(type)">
        <SimpleField
          :id="id"
          :value="value"
          :type="type"
          :disabled="disabled"
          :valid="!!errorMessage"
          :placeholder="placeholder"
          class="form-input"
          @update:value="updateModelValue($event)"
        />
      </div>

      <div v-else-if="type === 'tel'">
        <TelInput
          :id="id"
          :value="value"
          :disabled="disabled"
          :valid="!!errorMessage"
          :placeholder="placeholder"
          @update:value="updateModelValue($event)"
        />
      </div>

      <!-- Error message -->
      <p v-if="errorMessage" class="error-message">
        {{ getReferencelabel(errorMessage) }}
      </p>
    </div>
  </div>
</template>

<script>
import SimpleField from '@/components/inputs/SimpleField';
import Select from '@/components/inputs/Select';
import Radio from '@/components/inputs/Radio';
import TelInput from '@/components/inputs/TelInput';
import { getReferencelabel } from '@/mixins/utils';

export default {
  name: 'FormInput',
  components: { SimpleField, Select, Radio, TelInput },
  props: {
    id: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number, null],
      default: null,
    },
    placeholder: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
    errorMessage: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  emits: ['update:value', 'update:errorMessage'],
  setup(props, { emit }) {
    const simpleField = ['text', 'email', 'number', 'password'];

    const updateModelValue = (event) => {
      if (props.errorMessage) {
        emit('update:errorMessage', '');
      }

      emit('update:value', event);
    }
    
    return { 
      getReferencelabel,
      simpleField,
      updateModelValue
    };
  },
};
</script>